let notificationId = null;

const invitationHandler = {
    name: 'Ecocode\\Trustpilot\\Model\\Message\\InvitationMessage',
    fn: onInvitationProcessingMessageFound
};

Shopware.WorkerNotification.register('InvitationMessage', invitationHandler);

function onInvitationProcessingMessageFound(next, { $root, entry, notification }) {
    const invitationsCount = entry.size;

    // Create notification config object
    const config = {
        title: $root.$t('ecocode-trustpilot.notification.title'),
        message: $root.$tc(
            'ecocode-trustpilot.notification.message',
            invitationsCount
        ),
        variant: 'info',
        metadata: {
            size: invitationsCount
        },
        growl: false,
        isLoading: true
    };

    // Create new notification
    if (invitationsCount && notificationId === null) {
        notification.create(config).then((uuid) => {
            notificationId = uuid;
        });
        next();
    }

    // Update existing notification
    if (notificationId !== null) {
        config.uuid = notificationId;

        if (invitationsCount === 0) {
            config.message = $root.$t(
                'ecocode-trustpilot.notification.messageSuccess'
            );
            config.isLoading = false;
            config.growl = true;
        }
        notification.update(config);
    }

    next();
}

const helper = Shopware.WorkerNotification.initialize();
function middlewareFunctionWrapper(name, fn) {
    return (next, data) => {
        const entry = data.queue.find(
            (q) => q.name === name
        ) || null;
        const mergedData = { ...data, ...{ entry, name } };

        if (entry === null) {
            next();
        } else {
            fn.call(null, next, mergedData);
        }
    };
}

helper.use(middlewareFunctionWrapper(invitationHandler.name, invitationHandler.fn));
